export default __webpack_public_path__ + "static/media/Shadowed Valleys-21.6c85f01b.jpg";